module.exports = __webpack_public_path__ + "img/mandarin-prediction.f696ddb0.png";